import { Navigate, useParams } from "react-router-dom";

import { buildInsideSalesRepAgencyPath } from "@/components/inside-sales/RepAgencyDetailHoverHint";

/** Legacy path `/inside-sales/rep-agencies/:agencyId` → browse shell with agency selected. */
export function RepAgencyDetailPage() {
  const { agencyId: agencyIdRaw } = useParams<{ agencyId: string }>();
  const agencyId = agencyIdRaw != null ? Number.parseInt(agencyIdRaw, 10) : NaN;

  if (!Number.isFinite(agencyId) || agencyId <= 0) {
    return <Navigate to="/inside-sales/rep-agencies" replace />;
  }

  return <Navigate to={buildInsideSalesRepAgencyPath(agencyId)} replace />;
}
